import React from 'react';
import { SEO, SeoProps } from '../../components/seo/seo';

import { Waypoint } from '@omniafishing/core';
import { waypointImgURL } from './lib/waypoint_img_url';

interface MapPageSEOProps {
  sharedWaypoint?: Waypoint;
}
export const MapPageSEO = (props: MapPageSEOProps) => {
  const { sharedWaypoint } = props;
  const seoTitle = sharedWaypoint
    ? sharedWaypoint.name
    : 'Fishing Maps: Reports, Water Temps, Clarity, Waypoints, Depth Charts & More | Omnia Fishing';

  const seoDescription =
    'Explore fishing maps that show water temperature, clarity, structure, and more. See fishing reports, find fishing spots, and learn about the best fishing techniques.';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Map',
    name: 'Interactive Fishing Map',
    description:
      'Explore our interactive fishing map to find the best fishing spots, view detailed lake maps, and check weather conditions. Use the map layers to customize your view and get real-time updates on water temperature, clarity, and more.',
    url: 'https://www.omniafishing.com/map',
  };

  let seoProps: SeoProps = {
    title: seoTitle,
    description: seoDescription,
    schema,
  };

  if (sharedWaypoint) {
    seoProps = {
      ...seoProps,
      ogType: 'place',
      ogImage: waypointImgURL(sharedWaypoint),
    };
  }

  return <SEO {...seoProps} />;
};
